import React, { Component } from "react";
import PropTypes from "prop-types";
import classcat from "classcat";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { translate as t } from "../../../../infrastructure/translate/localization";

import { removeEmployeesBulkSession } from "../../remove-employees-bulk-session";
import TableEmployeeSummary from "./TableEmployeeSummary";
import ButtonLink from "../../../../app/components/commons/buttonLink/ButtonLink";
import CheckBox from "../../../../app/components/commons/checkBox/CheckBox";
import Pagination from "../../../../app/components/pagination/Pagination";

import "./section-employee-summary.scss";
import { displayUploadSessionEmployee } from "../../displays/display-upload-session-employee";

class SectionEmployeeSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      idsSelected: [],
      pages: 0,
      pageSize: 10,
      currentPage: 0,
    };
  }

  componentDidMount() {
    const { pageSize } = this.state;
    const { employees } = this.props;
    const pageCount = Math.ceil(employees.length / pageSize);
    this.setState({ pages: pageCount });
  }

  nextPage = () => {
    const { currentPage } = this.state;
    this.setState({ currentPage: currentPage + 1 });
  };

  prevPage = () => {
    const { currentPage } = this.state;
    this.setState({ currentPage: currentPage - 1 });
  };

  selectAllEmployees = () => {
    const { employees } = this.props;
    const { idsSelected } = this.state;
    if (employees.length === idsSelected.length) {
      return this.setState({ idsSelected: [] });
    }
    const ids = employees.map((e) => e.employeeId);
    return this.setState({ idsSelected: ids });
  };

  handlerSelectEmployee = (id) => {
    const { idsSelected } = this.state;
    if (idsSelected.find((employeeId) => employeeId === id)) {
      const removeIdSelected = idsSelected.filter(
        (employeeId) => employeeId !== id
      );
      return this.setState({ idsSelected: removeIdSelected });
    }
    return this.setState({ idsSelected: [...idsSelected, id] });
  };

  handlerRemoveSession = () => {
    const { idsSelected } = this.state;
    const { sectionType } = this.props;
    removeEmployeesBulkSession(idsSelected, sectionType);
  };

  handlerRemoveEmployeeOfRow = (id) => {
    const { sectionType } = this.props;
    removeEmployeesBulkSession([id], sectionType);
  };

  handlerEditEmployeeOfRow = (employee) => {
    displayUploadSessionEmployee({ employee });
  };

  render() {
    const {
      employees,
      showContent,
      sectionType,
      sectionTitle,
      icon,
      messageDescription,
      handlerShowContent,
    } = this.props;
    const { idsSelected, pages, pageSize, currentPage } = this.state;
    const currentEmployees = employees.slice(
      currentPage * pageSize,
      (currentPage + 1) * pageSize
    );
    if (employees.length === 0) return null;
    return (
      <div className="section-summary-container">
        <div className="section-summary">
          <div className="section-summary-type">
            <p className="type-title">{sectionTitle}</p>
            <span className={classcat(["type-description", sectionType])}>
              {icon && <FontAwesomeIcon icon={icon} />}
              {messageDescription && <p>{messageDescription}</p>}
            </span>
          </div>
          <ButtonLink
            icon={showContent ? "chevron-up" : "chevron-down"}
            iconPosition="left"
            textButton={
              showContent
                ? `${t("actions.hide")} ${t("employees-section.employees")}`
                : `${t("actions.show")} ${t("employees-section.employees")}`
            }
            handlerClick={handlerShowContent}
          />
        </div>
        {showContent && (
          <>
            {/* <Searcher
                            buttonText={t('actions.search')}
                            // value={this.state.search}
                            handledChange={e => this.setState({ searchText: e.target.value })}
                        /> */}

            <div className="section-summary-actions-group">
              <CheckBox
                active={employees.length === idsSelected.length}
                textDescription={t("common-messages.select-all", {
                  num: employees.length,
                })}
                handlerClick={this.selectAllEmployees}
              />
              <ButtonLink
                disabled={idsSelected.length === 0}
                icon="trash"
                textButton={t("edit-employees.delete-of-edition")}
                handlerClick={this.handlerRemoveSession}
              />
            </div>

            <TableEmployeeSummary
              employeesList={currentEmployees}
              employeesSelected={idsSelected}
              selectEmployee={(id) => this.handlerSelectEmployee(id)}
              editEmployee={(employee) =>
                this.handlerEditEmployeeOfRow(employee)
              }
              deleteEmployee={(id) => this.handlerRemoveEmployeeOfRow(id)}
            />

            <Pagination
              perPage={pageSize}
              pages={pages}
              current={currentPage}
              next={this.nextPage}
              prev={this.prevPage}
            />
          </>
        )}
      </div>
    );
  }
}

SectionEmployeeSummary.defaultProps = {
  showContent: false,
};

SectionEmployeeSummary.propTypes = {
  employees: PropTypes.array.isRequired,
  showContent: PropTypes.bool,
  sectionTitle: PropTypes.string.isRequired,
  sectionType: PropTypes.oneOf(["error", "warning", "modified", "no-modified"])
    .isRequired,
  icon: PropTypes.string.isRequired,
  messageDescription: PropTypes.string.isRequired,
  handlerShowContent: PropTypes.func.isRequired,
};

export default SectionEmployeeSummary;
